import { LogOut, Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

interface DashboardHeaderProps {
  brideName: string;
  groomName: string;
  weddingDate: Date;
  onSignOut: () => void;
}

const DashboardHeader = ({ brideName, groomName, weddingDate, onSignOut }: DashboardHeaderProps) => {
  const displayNames = brideName && groomName 
    ? `${brideName} y ${groomName}` 
    : 'Futuros Esposos';

  return (
    <header className="bg-card/80 backdrop-blur-sm border-b border-border sticky top-0 z-10">
      <div className="px-8 py-4 flex items-center justify-between">
        <div>
          <h1 className="font-serif text-2xl md:text-3xl font-medium text-foreground">
            Hola, <span className="text-primary">{displayNames}</span>
          </h1>
          <p className="text-muted-foreground text-sm mt-1">
            Tu boda: {format(weddingDate, "d 'de' MMMM, yyyy", { locale: es })}
          </p>
        </div>
        
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" className="relative">
            <Bell className="w-5 h-5 text-muted-foreground" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-primary rounded-full" />
          </Button>
          <Button variant="outline" size="sm" onClick={onSignOut}>
            <LogOut className="w-4 h-4 mr-2" />
            Salir
          </Button>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
